import { ViewportContext } from '../../../context/3catinfo/ViewportProvider';
import { useContext } from 'react';

export const useViewport = () => {
    const { viewport, isMobile, isOnlyMobile, isMobileDevice, zoomNavigator, typesViewport } = useContext(ViewportContext);

    return {
        viewport,
        isMobile,
        isOnlyMobile,
        isMobileDevice,
        zoomNavigator,
        typesViewport
    };
};
